import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import authnApi from "apis/eduidAuthn";
import { NotificationModal } from "components/Common/NotificationModal";
import { useAppDispatch, useAppSelector } from "eduid-hooks";
import { ACCOUNT_PATH } from "helperFunctions/paths";
import { useEffect, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router";
import authnSlice from "slices/Authn";
import { clearNotifications } from "slices/Notifications";
function isValidJson(jsonString) {
    try {
        JSON.parse(jsonString);
        return true;
    }
    catch (_a) {
        return false;
    }
}
export function AuthenticateModal() {
    const dispatch = useAppDispatch();
    const re_authenticate = useAppSelector((state) => state.authn.re_authenticate);
    const frontend_action = useAppSelector((state) => state.authn.frontend_action);
    const frontend_state = useAppSelector((state) => state.authn.frontend_state);
    const navigate = useNavigate();
    const [call_authenticate, { data, isError, isLoading }] = authnApi.useLazyAuthenticateQuery();
    // Parse frontend_state to extract description and method
    const { securityKeyDescription, method } = useMemo(() => {
        if (frontend_state && isValidJson(frontend_state)) {
            const parsedFrontendState = JSON.parse(frontend_state);
            return {
                securityKeyDescription: parsedFrontendState.description || null,
                method: parsedFrontendState.method || "",
            };
        }
        return { securityKeyDescription: null, method: "" };
    }, [frontend_state]);
    useEffect(() => {
        var _a;
        if (((_a = data === null || data === void 0 ? void 0 : data.payload) === null || _a === void 0 ? void 0 : _a.location) && !isLoading && !isError) {
            globalThis.location.href = data.payload.location;
        }
    }, [data, isError, isLoading]);
    function handleAuthenticate() {
        dispatch(authnSlice.actions.setReAuthenticate(false));
        dispatch(clearNotifications());
        call_authenticate({ frontend_action: frontend_action, frontend_state: frontend_state });
    }
    function handleCloseModal() {
        // navigate to account when user cancel re-authentication
        if (frontend_action === "changepwAuthn" && re_authenticate) {
            navigate(ACCOUNT_PATH);
        }
        dispatch(authnSlice.actions.setAuthnFrontendReset());
        dispatch(authnSlice.actions.setReAuthenticate(false));
    }
    return (_jsx(NotificationModal, { id: "security-confirm-modal", title: _jsx(FormattedMessage, { id: "authenticateModal.title", defaultMessage: "Security check", description: "Dashboard change password modal title" }), mainText: _jsxs(_Fragment, { children: [_jsx(FormattedMessage, { id: "authenticateModal.reloginNote", description: "security zone modal", defaultMessage: "You need to log in again to perform the requested action." }), _jsx("br", {}), frontend_action === "verifyCredential" && (_jsxs("p", { className: "help-text", children: [_jsx(FormattedMessage, { id: "authenticateModal.useKeyNote", description: "security zone modal", defaultMessage: "Note: please use your security key {securityKeyDescription} during the login process. ", values: {
                                securityKeyDescription: _jsx("strong", { children: securityKeyDescription }),
                            } }), "\u00A0", _jsx(FormattedMessage, { id: "authenticateModal.redirectNote", description: "security zone modal", defaultMessage: " After logging in, you will be redirected to {externalPage} page to verify your security key.", values: {
                                securityKeyDescription: _jsx("strong", { children: securityKeyDescription }),
                                externalPage: _jsx("strong", { children: method ? method.replace("_eid", "").toUpperCase() : "External" }),
                            } })] })), frontend_action === "removeSecurityKeyAuthn" && (_jsx("p", { className: "help-text", children: _jsx(FormattedMessage, { id: "authenticateModal.keyRemovedNote", description: "security zone modal", defaultMessage: "Note: Your security key {securityKeyDescription} will be removed after you log in.", values: {
                            securityKeyDescription: _jsx("strong", { children: securityKeyDescription }),
                        } }) })), frontend_action === "removeIdentity" && (_jsx("p", { className: "help-text", children: _jsx(FormattedMessage, { id: "authenticateModal.disconnectNote", description: "security zone modal", defaultMessage: "Note: continuing will disconnect your real identity from your eduID after you log in." }) })), frontend_action === "addSecurityKeyAuthn" && (_jsx("p", { className: "help-text", children: _jsx(FormattedMessage, { id: "authenticateModal.nameKeyNote", description: "security zone modal", defaultMessage: "Note: After logging in, you'll be asked to enter a name for your security key." }) }))] }), showModal: re_authenticate, closeModal: handleCloseModal, acceptModal: handleAuthenticate, acceptButtonText: _jsx(FormattedMessage, { id: "common.continue", defaultMessage: "Continue", description: "continue button" }) }));
}
